<div class="help-text-oval"
     [ngbTooltip]="text"
     [tooltipClass]="tooltipClass"
     [openDelay]="300"
     [autoClose]="true"
     #tooltip="ngbTooltip"
     (click)="tooltip.open()"
     placement="bottom-left">
  <div class="info-text">i</div>
</div>
